import styled from 'styled-components';

export const CardContainer = styled.div`
  /* O card principal */
  background: #FFFFFF;
  border: 1px solid #E0E0E0;
  border-left: 5px solid #E53935; /* Cor vermelha da Takeat */
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px; /* Espaço para os campos abaixo */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05); /* Sombra sutil para destacar */
`;

export const CardTitle = styled.h3`
  /* Título da seção */
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-top: 0;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 10px; /* Espaço entre o ícone e o texto */
`;

export const InfoBox = styled.div`
  /* A caixa de aviso amarela/cinza */
  display: flex;
  align-items: flex-start; /* Alinha o ícone no topo */
  gap: 12px;
  background: #F9F9F9; /* Fundo levemente acinzentado */
  border-radius: 6px;
  padding: 16px;
  font-size: 13px;
  margin-bottom: 10px;
  color: #444;
  line-height: 1.6;

  strong {
    color: #000; /* Dá mais destaque ao <strong> */
  }
`;

export const InfoIcon = styled.span`
  /* O ícone de informação */
  font-size: 20px;
  color: #E53935; /* Cor da marca para o ícone */
  margin-top: 1px; /* Ajuste fino de alinhamento */
`;

export const FieldsGrid = styled.div`
  /* Grid para os dois campos de <select> */
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;

  /* Em telas menores, os campos ficam um abaixo do outro */
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const FieldGroup = styled.div`
  /* Agrupador de Label + Select */
  display: flex;
  flex-direction: column;
`;